/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Outsideairhumiditydefect3Inputs */



/**
* | output |
* | --- |
* | "Fresh air humidity sensor fault" |
*
* @param {Ahu_History_Key_Outsideairhumiditydefect3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_outsideairhumiditydefect3 = /** @type {((inputs?: Ahu_History_Key_Outsideairhumiditydefect3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Outsideairhumiditydefect3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Fresh air humidity sensor fault")
	return /** @type {LocalizedString} */ ("Défaut sonde hygrométrie air neuf")
});
export { ahu_history_key_outsideairhumiditydefect3 as "ahu_history_key_outsideAirHumidityDefect" }